import React from "react";
import s from "./style.module.css";
import { BsBookmarks } from "react-icons/bs";

export default function MentionsLegales() {
  return (
    <div className={`${s.global}`}>
      <div className={`${s.title}`}>
        <BsBookmarks className={s.icon}/> Mentions légales
      </div>
      <div>
        <p>
          Ce site est édité par Charly HAZARD : adresse de résidence communiquée
          sur demande.
        </p>
        <p>
          Le site est hébergé par{" "}
          <a className={`${s.links}`} href="https://www.ovhcloud.com">
            OVH{" "}
          </a>
          : 2 rue Kellermann 59100 Roubaix
        </p>
        <p>
          Adresse de contact de Charly HAZARD :{" "}
          <a className={`${s.links}`} href="mailto:contact@dev-hop.fr">
            contact@dev-hop.fr
          </a>
        </p>
        <p>
          Le site "Dev-Hop" a pour objectif de présenter le parcours
          professionnel, les compétences et les expériences de Charly HAZARD. Il
          ne propose pas encore de services commerciaux. Toute demande de
          mission sera encadrée par un contrat une fois un statut légal
          enregistré.
        </p>
        <p>
          Tout le contenu du site, incluant textes, images, éléments graphiques
          et logos créés par Charly HAZARD, est la propriété exclusive de Charly
          HAZARD, sauf mention contraire.
          <br />
          Les logos d’entreprise et les icônes des technologies utilisés sur ce
          site sont la propriété de leurs détenteurs respectifs et sont
          présentés uniquement à titre informatif dans le cadre de la
          présentation des expériences professionnelles et des compétences de
          Charly HAZARD. Leur utilisation ne sous-entend aucune affiliation,
          partenariat ou approbation de la part de ces entreprises ou
          technologies.
          <br />
          Toute reproduction, représentation ou utilisation des contenus de ce
          site, partielle ou totale, est interdite sans autorisation préalable.
        </p>
        <p>
          Ce site utilise Google reCAPTCHA pour se protéger contre les spams et
          les abus. Cela implique la collecte de données personnelles (adresse
          IP, comportement de navigation, etc.) conformément à la politique de
          confidentialité de Google. Ces données sont utilisées pour vérifier
          que les actions effectuées sur le site proviennent d’un utilisateur
          humain et non d’un bot. Pour en savoir plus, consultez la{" "}
          <a
            className={`${s.links}`}
            href="https://policies.google.com/privacy"
          >
            politique de confidentialité{" "}
          </a>
          et les{" "}
          <a className={`${s.links}`} href="https://policies.google.com/terms">
            conditions d'utilisation{" "}
          </a>
          de Google. Aucune autre donnée personnelle n’est collectée ou stockée
          sans le consentement explicite des utilisateurs.
        </p>
      </div>
    </div>
  );
}
